/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Col, Container, Row } from "react-bootstrap";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { useParams } from "react-router-dom";
import Loader from "../../Loader";
import MsgLoading from "../../MsgLoading";
import BtnLoader from "../../BtnLoader";
import ReactTost from "../../ReactTost";
import { useTranslation } from 'react-i18next';
import DOMPurify from 'isomorphic-dompurify';
import { marked } from 'marked';
import { BeatLoader } from "react-spinners";

const ChatbotData = (props) => {
  const [loadingData,setLoadingData ] = useState(false);
  const [loading,setLoading ] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState("");
  const [showAlert, setShowAlert] = useState(false)

  const {id, bot } = useParams();
  const [headerLogo, setHeaderLogo] = useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const chatContainerRef = useRef(null);
  const chatMessageRef = useRef(null);
  // const [messageType, setMessageType] = useState();
  const [placeHolder, setPlaceHolder] = useState();
  const [sid, setSid] = useState();
  const [message, setMessage] = useState();
  const [chatHistoryData, setChatHistoryData] = useState([]);
  const [isFirst, setIsFirst] = useState(true);
  const [color, setColor] = useState("#05204a");
  const [headerColor, setHeaderColor] = useState("#416cbe");
  const [name, setName] = useState();
  const [initialMsg, setInitialMsg] = useState();
  const [messageToChat, setMessageToChat] = useState(false);
  const [suggestedQuestion, setSuggestedQuestion] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [typeIndicator, setTypeIndicator] = useState(false);
  const chatRef = useRef(null);
  //const { id } = useParams();
  const { t } = useTranslation();


  useEffect(() => {
    const getSid = () => {
      setIsLoading(true);
      axios
        .get(`${API_URL}/${API_VERSION}/bot/init/${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setIsLoading(false);
          if (response.data) {
            if (response.data.sid) {
              localStorage.setItem(bot, response.data.sid);
              setSid(response.data.sid);
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    };

    if (bot) {
      const sidList = localStorage.getItem(bot);
      setSid(sidList);
      if (!sidList) {
        getSid();
      }
    }
  }, [API_URL, API_VERSION, bot]);

  async function userQuestion() {
    let isNew = 1;
    let isKey = chatHistoryData.length;
    let __msg__ = "";
    chatScrollToBottom();
    await fetchEventSource(
      `${process.env.REACT_APP_STRING_CHAT_URL}/bot/query-stream/${bot}?text=${message}&sid=${sid}`,
      {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        onopen(res) {
          if (res.ok && res.status === 200) {
            console.log("Connection made ", res);
          } else if (
            res.status >= 400 &&
            res.status < 500 &&
            res.status !== 429
          ) {
            console.log("Client side error ", res);
          }
        },
        onmessage(event) {
          const messageText = JSON.parse(event.data).token;
          if (messageText !== "[END]") {
            __msg__ = __msg__ + messageText;
            const userMessage = (
              <li className="sender chatGPTreplay">
                <div className="cont">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        marked.parse(__msg__)
                      ),
                    }}
                  ></span>
                </div>
              </li>
            );
            if (isNew) {
              isNew = false;
              setChatHistoryData((prevHistory) => [
                ...prevHistory,
                userMessage,
              ]);
              setTypeIndicator(false);
            } else {
              setChatHistoryData((prevHistory) => {
                const updatedHistory = [...prevHistory];
                updatedHistory[parseInt(isKey + 1)] = userMessage;
                return updatedHistory;
              });
              setTypeIndicator(false);
            }
          }
        },
        onclose() {
          console.log("Connection closed by the server");
          setTypeIndicator(false);
          chatScrollToBottom();
        },
        onerror(err) {
          console.log("There was an error from server", err);
          setTypeIndicator(false);
          chatScrollToBottom();
        },
      }
    );
  }

  async function callQuestion() {
    setIsDisable(() => true);
    // e.preventDefault();
    chatMessageRef.current.value = "";
    if (sid && message) {
      const userMessage = (
        <li className="repaly userInput" style={{ background: color }}>
          <div className="cont">
            <span>{message}</span>
          </div>
        </li>
      );
      setChatHistoryData((prevHistory) => [...prevHistory, userMessage]);
      // setIsLoading(true);
      setMessageToChat(false);
      setTypeIndicator(true);
      await userQuestion();
      setIsDisable(() => false);
    }
  }

  function handleKeyPress(e) {
    e.preventDefault();
    callQuestion();
    return false;
  }

  let chatTimeoutId = null;
  function chatScrollToBottom () {
    // if (chatTimeoutId)  {
    //   clearTimeout(chatTimeoutId);
    // }
    // chatTimeoutId = setTimeout(() => {
    //   chatRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }, 100);
  }

  // useEffect(() => {
  //   if (chatContainerRef) {
  //     chatContainerRef.current.addEventListener("DOMNodeInserted", (event) => {
  //       const { currentTarget: target } = event;
  //       target.scroll({ top: target.scrollHeight, behavior: "smooth" });
  //     });
  //   }
  // }, [chatHistoryData]);
  useEffect(() => {
    const container = chatContainerRef?.current;
    if (!container) return;
  
    const observer = new MutationObserver(() => {
      container.scroll({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    });
  
    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  
    return () => observer.disconnect();
  }, [chatHistoryData]);

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
    }
    axios.get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },

    }).then((response) => {
      console.log(response);
      const msg = response.data.chatInterface.initialMsg;
      setInitialMsg(msg);
      setName(response.data.name);
      setColor(response.data.chatInterface.color);
      setHeaderColor(response.data.chatInterface.headerColor);
      setPlaceHolder(response.data.chatInterface.messageType);
      if (response.data.chatInterface.suggestedMsg) {
        setSuggestedQuestion(response.data.chatInterface.suggestedMsg.split("\n"))
      }
      setHeaderLogo(response.data.chatInterface.headerLogo);
      resetChatUi(msg);
    }).catch((err) => {
      console.log(err)
    })
  }, [API_URL, API_VERSION, bot, isFirst]);

  function resetChatUi(msg) {
    const _userMessage = (
      <li className="sender chatGPTreplay">
        <div className="cont">
          <span>{msg}</span>
        </div>
      </li>
    );
    setChatHistoryData([]);
    setChatHistoryData((_prevHistory) => [..._prevHistory, _userMessage]);
  }

  function checkMessageLimit() {
    setLoading(true);
    let sID = sid;
    axios.post(`${API_URL}/${API_VERSION}/bot/checkMessageLimit/${bot}`, {
      sID,
    },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      }
    ).then((response) => {

      setLoading(false);
      if (response.data.ans.limit === true) {
        console.log("calling question api")
        callQuestion();
      } else {
        setType("Danger");
        setMessage(t("Message limit exceeded."));
        setShowAlert(true);
      }
    })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went wrong"));
        setShowAlert(true);
      });
  }

  useEffect(() => {
    if (messageToChat && message) {
      callQuestion();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToChat, message]);

  const buttonStyle = {
    pointerEvents: isDisable ? "none" : "auto",
  };

  return (
    <>
      <section className="chating_box">
      <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          <Row className="justify-content-center">
            {/* <Col md={6}></Col> */}
            <Col md={12}>
              <div className="chatingwrap">
                <div className="chating_head" style={{ background: headerColor }}>
                  <div className="brand">
                    <span>{name}</span>
                    {/* <div className="icon">
                      <img
                        src={
                          headerLogo
                            ? headerLogo
                            : "https://seekicon.com/free-icon-download/chat_7.svg"
                        }
                        alt=""
                      />
                    </div> */}
                  </div>
                  <div className="refresh" onClick={() => resetChatUi()}>
                    <i className="fa-solid fa-rotate"></i>
                  </div>
                </div>
                <div className="chating_area" ref={chatContainerRef}>
                  {loadingData ? <Loader /> :
                    <ul>
                      {chatHistoryData}
                      {typeIndicator ? <li className="sender chatGPTreplay">
                        <div class="beat-loader">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                      </li> : null} 
                      <div ref={chatRef}/>
                    </ul>
                  }
                </div>
                <div className="sugbox">
                  {suggestedQuestion &&
                    suggestedQuestion.map((question) => {
                      return (
                        <span
                          onClick={(e) => {
                            setMessageToChat(true);
                            setMessage(e.target.textContent);
                          }}
                        >
                          {question}
                        </span>
                      );
                    })}
                </div>
                <div className="chating_foot">
                  <form onSubmit={(e) => handleKeyPress(e)}>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="message…"
                      placeholder={placeHolder}
                      ref={chatMessageRef}
                      disabled={isDisable}
                      onInput={(e) => setMessage(e.target.value)}
                    />
                    <button
                      style={{background : color}}
                      type="button"
                      className="button send_btn"
                      onClick={(e) => checkMessageLimit()}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-send" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="" />
                        <path d="M10 14l11 -11" />
                        <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                      </svg>
                    </button>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatbotData;
